import { createStructuredSelector } from 'reselect';

const getAbilities = state => state.abilities;

const abilitiesSelector = createStructuredSelector({
  abilities: getAbilities
});

export { abilitiesSelector };
